import { Button, Container, Message, Stack, Text } from "basis";
import { SvgInline } from "components/SvgInline/SvgInline";
import React, { Dispatch } from "react";
import { Actions, ActionTypes } from "./types";

interface Props {
  dispatch: Dispatch<Actions>;
  title: string;
  message: string;
}

export const VerifyError = ({ dispatch, title, message }: Props) => (
  <Stack gap="8">
    <SvgInline name="icon-security-lock" size="92" />
    <Text textStyle="heading5" textStyle-sm="heading4">
      Verify Mobile Number
    </Text>
    <Message severity="info-or-minor" bg="secondary.pink.t30" title={title}>
      {message}
    </Message>
    <Container width="100%" width-sm="200">
      <Button
        width="100%"
        onClick={() => {
          dispatch({ type: ActionTypes.BACK });
        }}
      >
        Go Back
      </Button>
    </Container>
  </Stack>
);
